const rootActionPath = 'core/navigationTOF';

export const NAVIGATION_TOF_IS_TOGGLED = `${rootActionPath}/IS_TOGGLED`;
